import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, PlusCircle, History, BarChart3, TrendingUp,
  Settings as SettingsIcon, LogOut, X,
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import UserAvatar from './UserAvatar';

export default function Sidebar({ isOpen, closeMobile, width }) {
  const { user, isDark, logout } = useAuth();
  const navigate = useNavigate();
  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/add', icon: PlusCircle, label: 'Add Income' },
    { path: '/transactions', icon: History, label: 'Transactions' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
    { path: '/forecast', icon: TrendingUp, label: 'Forecast' },
    { path: '/settings', icon: SettingsIcon, label: 'Settings' },
  ];

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'mobile-open' : ''}`} onClick={closeMobile} />
      <aside className={`sidebar ${isOpen ? 'mobile-open' : ''}`} style={{ width: width }}>
        <div className="sidebar-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img
              src={isDark ? '/logo-txt.svg' : '/logo-light.svg'}
              alt="GigFlow"
              className="logo-img"
              style={{ height: '95px', width: 'auto', cursor: 'pointer', display: 'block' }}
              onClick={() => { navigate('/'); closeMobile(); }}
            />
            <button className="mobile-menu-btn" style={{ border: 'none', margin: 0 }} onClick={closeMobile}><X size={24} /></button>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} onClick={closeMobile} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <item.icon size={20} /><span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user-btn" onClick={() => { navigate('/settings'); closeMobile(); }}>
            <UserAvatar src={user?.avatar} name={user?.name} size={40} fontSize="0.95rem" />

            <div style={{ overflow: 'hidden', flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: '0.9rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user?.name || 'User'}
              </div>
            </div>
            <SettingsIcon size={16} color="var(--text-secondary)" />
          </div>
          <button className="theme-toggle-btn" onClick={logout} style={{ justifyContent: 'center', color: 'var(--accent-danger)', borderColor: 'rgba(239,68,68,0.3)', width: '100%' }}><LogOut size={18} /> <span>Log Out</span></button>
        </div>
      </aside>
    </>
  );
}
